export const asyncExperienceSounds = {
    fadeAway: { src: '/audio/08_FINAL_CARD_FADEAWAY.mp3' },
    nextCard1: { src: '/audio/async/sfx_card_01.ogg', volume: 0.3 },
    nextCard2: { src: '/audio/async/sfx_card_02.ogg', volume: 0.3 },
    nextCard3: { src: '/audio/async/sfx_card_03.ogg', volume: 0.3 },
    cardFanOut: { src: '/audio/async/sfx_fan_01.ogg', volume: 0.1 },
    badgeShine: { src: '/audio/async/sfx_shine_01.ogg', volume: 0.3 },
    cardStackRise: { src: '/audio/07_NEXT_PREV.mp3' },
    cardStackFall: { src: '/audio/06_CARD_FLIP.mp3' },

    swoosh: { src: '/audio/async/sfx_swoosh_01.ogg', volume: 0.3 },
};
